import { render, staticRenderFns } from "./ct-company.vue?vue&type=template&id=0ec8fd43&scoped=true"
import script from "./ct-company.vue?vue&type=script&lang=js"
export * from "./ct-company.vue?vue&type=script&lang=js"
import style0 from "./ct-company.vue?vue&type=style&index=0&id=0ec8fd43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8fd43",
  null
  
)

export default component.exports